import './App.css';
function Home() {
    return (
        <>
            <html lang="en">

                <head>


                </head>


                <img src="Recell.png" alt="logo" className="center" />
                <h1 style={{ textAlign: "center" }}>welcome to Recell
                    <h2 style={{ textAlign: "center" }}>Recycling EV Batteries made easy</h2>
                    Give your batteries a second life</h1>
                <p style={{ textAlign: "center" }}>and contribute to Stopping the recycling<br /> problem that has been forseen by experts </p>

            </html>
        </>
    );
}

export default Home;